__turbopack_context__.v({
  "forced-error": "checkbox-card-module__2dFDLa__forced-error",
  "label": "checkbox-card-module__2dFDLa__label",
  "text": "checkbox-card-module__2dFDLa__text",
  "wrapper": "checkbox-card-module__2dFDLa__wrapper",
});
